'use strict';

import angular from 'angular';

export default angular.module('fplTruescapeComApp.constants', [])
  .constant('appConfig', require('../../server/config/environment/shared'))
  .constant('langConfig', require('../../server/config/environment/languages'))
  .name;



// WEBPACK FOOTER //
// ./client/app/app.constants.js